import { render, staticRenderFns } from "./currentInfo.vue?vue&type=template&id=54f19422&scoped=true"
import script from "./currentInfo.vue?vue&type=script&lang=js"
export * from "./currentInfo.vue?vue&type=script&lang=js"
import style0 from "./currentInfo.vue?vue&type=style&index=0&id=54f19422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f19422",
  null
  
)

export default component.exports